import { ChevronDown } from '@griply/assets';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AddGoalMenuItems } from 'shared/components/connected/add-goal-menu-items';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { PopupMenu, PopupMenuList } from 'shared/components/ui/popup-menu';
import { useTheme } from 'styled-components';

export const TimelineAddButton: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const openMenu = () => setIsMenuOpen(true);
  const closeMenu = () => setIsMenuOpen(false);

  return theme.isMobile ? null : (
    <>
      <Button
        ref={buttonRef}
        onClick={openMenu}
        size={Sizes.Small}
        variant={Variants.Contained}
        color={Colors.Primary}
        endIcon={ChevronDown}
        iconStrokeWidth={2.5}
        preventDrag
      >
        {t('general.labels.new')}
      </Button>
      {isMenuOpen && (
        <PopupMenu
          referenceElement={buttonRef}
          onOutside={closeMenu}
          position="bottom-end"
        >
          <PopupMenuList>
            <AddGoalMenuItems parentIds={[]} onClose={closeMenu} />
          </PopupMenuList>
        </PopupMenu>
      )}
    </>
  );
};
